import HTTP_GESCOM from '../HTTP_GESCOM';
import { mapContactsResponse } from '@/mapping/contact.mapping';
import buildGescomContact from '@/services/contact/prepareEnvoiBack';

const URL_BASE = 'commun/Contact/';

export async function postContact(data) {
  const gescomData = buildGescomContact(data);
  delete gescomData.id;

  const response = await HTTP_GESCOM.post(URL_BASE + 'CreateAsync', gescomData);
  return response;
}

export async function getContactClient(idTiers) {
  const response = await HTTP_GESCOM.get(URL_BASE + 'GetAllByTiersAsync/?TiersId=' + idTiers);
  const contacts = mapContactsResponse(response);
  return { data: contacts };
}

export async function updateContact(data) {
  const gescomData = buildGescomContact(data);

  const response = await HTTP_GESCOM.put(URL_BASE + 'UpdateAsync', gescomData);
  return response;
}
